<template>
  <section class="services-box" id="services">
    <div class="section-container-header-box fade-up-animation">
      <p class="list-text">Services</p>
    </div>
    <div class="services-box-items">
      <nuxt-link
        v-for="service in services"
        :key="service.slug"
        :to="`/services#${service.slug}`"
        class="services-box-items-item fade-up-animation"
        :aria-label="`Learn more about ${service.name}`">
        <div class="services-box-items-item-image">
          <img :src="service.image" :alt="service.name" />
        </div>
        <h3 class="heading-3 fade-up-animation text-center" v-html="service.name"></h3>
      </nuxt-link>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useFadeUpObserver } from '@/composables/useFadeUpObserver';
import { services } from '@/data/services';

useFadeUpObserver();
</script>
